import styled from 'styled-components';

import { palette } from '~/theme';
import PlainCard from '~atoms/PlainCard';

export const imgClassName = 'skeleton-card--color--img';
export const lineClassName = 'skeleton-card--color--line';

const skeletonCss: React.CSSProperties = {
  borderRadius: '10rem !important',
  backgroundColor: `${palette.concrete} !important`,
};

export const Container = styled(PlainCard)(({ theme }) => ({
  padding: '8rem',
  maxInlineSize: theme.legacyDimensions.colorCardMaxWidth,

  [`.${imgClassName}`]: {
    width: '100%',
    marginBlockEnd: '10rem',
  },
  [`.${imgClassName} > *:first-child`]: {
    ...skeletonCss,
    width: 'inherit !important',
    height: '142rem !important',
  },

  [`.${lineClassName}`]: {
    marginBlockEnd: '6rem',
  },
  [`.${lineClassName} > *:first-child`]: {
    ...skeletonCss,
    minWidth: '0 !important',
    height: '20rem !important',
  },
}));
